import { isCompleteColor } from '@/components/EventTypes/utils/getCSSBackgroundColor';
import { DEFAULT_EVENT_TYPE_COLOR } from './initialState';

const VALID_CLASSIFICATIONS = ['positive', 'negative', 'neutral'];

const mapApiClosuresToForm = (closures = []) =>
  closures.map((closure) => ({
    id: closure.id,
    classification: VALID_CLASSIFICATIONS.includes(closure.qualification_label)
      ? closure.qualification_label
      : null,
    name: closure.name,
    locked: closure.is_editable === false,
  }));

const hasOwnerReportContent = (subject, message) =>
  Boolean(subject?.trim()) || Boolean(message?.trim());

const mapEventTypeToForm = (apiEventType) => {
  const ownerSubject = apiEventType.body_subject_template ?? '';
  const ownerMessage = apiEventType.body_template ?? '';
  const contactsRequired = apiEventType.is_self_scheduled
    ? 1
    : apiEventType.contacts_required ?? 0;

  const color = apiEventType.color?.replace(/^#/, '') ?? '';

  return {
    id: apiEventType.id,
    canDelete: apiEventType.can_delete,
    editableFields: apiEventType.editable_fields,

    name: apiEventType.name ?? '',
    color,
    lastValidColor: isCompleteColor(color) ? color : DEFAULT_EVENT_TYPE_COLOR,
    isVisit: apiEventType.is_visit ?? false,
    showInOwnerReport: apiEventType.count_for_statistics ?? false,

    isSelfScheduled: apiEventType.is_self_scheduled ?? false,

    requiredFields: {
      users: apiEventType.is_self_scheduled
        ? 1
        : apiEventType.users_required ?? 0,
      contacts: contactsRequired,
      properties: apiEventType.is_self_scheduled
        ? 1
        : apiEventType.properties_required ?? 0,
    },

    notifyUsers: {
      enabled: (apiEventType.notify_agent_start ?? 0) > 0,
      value: apiEventType.notify_agent_start || 120,
      unit: 'minutes',
      by: 'email',
      // mail_agent_start is mapped on save; UI only supports email for users
    },

    notifyContacts: {
      enabled:
        (apiEventType.send_report_to_contact ?? false) && contactsRequired > 0,
      items: [
        {
          id: 'contact-1',
          value: apiEventType.notify_contact_start || 120,
          unit: 'minutes',
          // API only exposes notify_contact_start — no channel per row
          by: 'email',
        },
      ],
    },

    contactsSubject: apiEventType.contact_subject_template ?? '',
    contactsMessage: apiEventType.contact_body_template ?? '',

    requiredReport: apiEventType.need_report ?? false,
    closures: mapApiClosuresToForm(apiEventType.closures),

    ownerReportEnabled: hasOwnerReportContent(ownerSubject, ownerMessage),
    ownerSubject,
    ownerMessage,

    notifyAgentEnd: apiEventType.notify_agent_end ?? false,
    mailAgentEnd: apiEventType.mail_agent_end ?? false,
  };
};

export default mapEventTypeToForm;
